import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchFormElementsNoIntent, emailIntentSelected } from '../actions/action-email-no-intent';
import { selectTopicResult } from '../actions/action-select-topic';
import { trackLink } from '../../lib/analytics-helper';
import TopicSelection from '../components/TopicSelection';
import EmailForm from '../containers/EmailForm';
import i18n from '../../lib/reacti18n';
import * as shape from '../constants/PropTypesShapes';

const email = {
  header: i18n.message('smarthelp/emailUs.emailUs.header'),
  instruction: i18n.message('smarthelp/emailUs.emailUs.instruction'),
  placeholder1: i18n.message('smarthelp/emailUs.emailUs.placeholder1'),
  placeholder2: i18n.message('smarthelp/emailUs.emailUs.placeholder2'),
  error: i18n.message('smarthelp/emailUs.emailUs.errors'),
};

class EmailNoIntent extends Component {

  static renderError() {
    return (<div className="error-email-no-intent">
      <div className="vx_icon vx_icon-large vx_icon-critical-large test" />
      <div className="error-message-email-no-intent">{email.error.message}</div>
    </div>);
  }

  constructor(props) {
    super(props);
    this.state = {
      topicSelections: props.topicTree,
      value: [email.placeholder1, email.placeholder2, email.placeholder2, email.placeholder2],
      label: [email.placeholder1, email.placeholder2, email.placeholder2, email.placeholder2],
      isFirstTime: true,
    };
    this.onTopicSelection = this.onTopicSelection.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.isFirstTime && nextProps.topicSelection) {
      this.setState({
        topicSelections: nextProps.topicTree,
        isFirstTime: false,
      });
    }
  }

  onTopicSelection({ topicRefId, topicId, topicName, topicObj, level }) {
    trackLink({ id: 'emailByPassPage', link: `smarthelp-email-select|L${level + 1}|${topicRefId}` });
    // Set dropdown value
    const value = this.state.value.map((eachValue, index) => {
      if (index > level) {
        return email.placeholder2;
      } else if (index === level) {
        return topicRefId;
      }
      return eachValue;
    });
    this.setState({
      value,
    });
    // set label to empty to hide it
    const label = this.state.label.map((eachValue, index) => {
      if (index > level) {
        return email.placeholder2;
      } else if (index === level) {
        return '';
      }
      return eachValue;
    });
    this.setState({
      label,
    });

    this.props.emailIntentSelected(topicName);

    // Set local state for current level Topic tree selection
    const updatedSelection = this.state.topicSelections.slice(0, level + 1);
    updatedSelection.push(topicObj);
    this.setState({
      topicSelections: updatedSelection,
    });

    // check if its a leafnode, then fetch email form and trigger select topic result event
    if (topicObj && topicObj.leaf_node) {
      this.props.selectTopicResult({
        topicId,
        topicName,
        topicRefId,
      });
      this.props.fetchFormElementsNoIntent(topicId);
    }
  }

  renderDropDown(topic, level) {
    let topicSelection = null;
    if (topic && topic.sub_topics) {
      const topicObject = topic.sub_topics.map(eachTopic => ({
        topicRefId: eachTopic.ref_id,
        topicId: eachTopic.topic_id,
        topicName: eachTopic.topic_name,
        topicObj: eachTopic,
        level,
      }));

      const options = topicObject.map(eachTopic => ({
        label: eachTopic.topicName,
        value: eachTopic.topicRefId,
      }));

      topicSelection = (<TopicSelection
        options={options}
        topics={topicObject}
        level={level}
        onChange={this.onTopicSelection}
        label={this.state.label[level]}
        value={this.state.value[level]}
        placeholder={this.state.value[level]}
      />);
    }
    return topicSelection;
  }

  render() {
    if (this.props.error) {
      return EmailNoIntent.renderError();
    } else if (this.props.display) {
      return (<div className="email-no-intent">
        <h1>{email.header}</h1>
        <div className="email-no-intent-instruction">{email.instruction}</div>
        {this.state.topicSelections.map((topic, index) => this.renderDropDown(topic, index))}
        <EmailForm />
      </div>);
    }
    return null;
  }

}
// QuickAnswer PropTypes
EmailNoIntent.propTypes = {
  topicTree: PropTypes.arrayOf(PropTypes.shape(shape.TOPICTREE)),
  topicSelection: PropTypes.shape(shape.TOPICTREE), // eslint-disable-line react/no-unused-prop-types
  fetchFormElementsNoIntent: PropTypes.func.isRequired,
  selectTopicResult: PropTypes.func.isRequired,
  emailIntentSelected: PropTypes.func.isRequired,
  error: PropTypes.bool,
  display: PropTypes.bool,
};

EmailNoIntent.defaultProps = {
  topicTree: [],
  topicSelection: undefined,
  error: false,
  display: false,
};

function mapStateToProps(state) {
  const topicTree = [];
  topicTree.push(state.topicTree.topicTreeSelection);
  return {
    topicTree,
    topicSelection: state.topicTree.topicTreeSelection,
    error: state.topicTree.error,
    display: state.topicTree.display,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchFormElementsNoIntent, selectTopicResult, emailIntentSelected }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailNoIntent);
